import * as $ from 'jquery';
import 'bootstrap';
import 'slick';

export class initSignpostCarousel {
	private $scope = $('.signpost-container .seq');

	/**
	 * @function init
	 * init all mobile signposts found
	 */
	init(): void {
		let _self = this;
		_self.$scope.each(function(i:number, el:any) {
			_self.initSignpost(el);
		});
	}

	/**
	 * @function initSignpost
	 * init carousel if mobile device detected on page load
	 */
  initSignpost(el:any): void {
  	if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
	    let options:any = {
	      accessibility: true,
				fade: true,
				autoplay: true,
				autoplaySpeed: 4000,
				pauseOnHover: false,
				pauseOnFocus: true,
				dots: true,
				dotsClass: 'seq-pagination slick-dots',
				arrows: false
	    };

	    let wrapper = $(el);
	    let carousel = wrapper.find('.seq-canvas');

			// init signpost carousel
			carousel.slick(options);
	  }
  }
}

let scope:Element = document.querySelector('.signpost-container');
if (scope){
	try {
	  let initsignpostsarousel = new initSignpostCarousel();
	    	initsignpostsarousel.init();
	} catch(e) {console.error(e);}
}
